import { render, staticRenderFns } from "./Medios.vue?vue&type=template&id=3aaf1b4b&scoped=true"
import script from "./Medios.vue?vue&type=script&lang=js"
export * from "./Medios.vue?vue&type=script&lang=js"
import style0 from "./Medios.vue?vue&type=style&index=0&id=3aaf1b4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf1b4b",
  null
  
)

export default component.exports